export type MixpanelGlobal = {
    set_config?: (config: Record<string, unknown>) => void;
    start_session_recording?: () => void;
    stop_session_recording?: () => void;
};

const getMixpanel = (): MixpanelGlobal | undefined => {
    if (typeof window.mixpanel?.set_config !== 'function') {
        return undefined;
    }
    return window.mixpanel;
};

const applyPersistenceConsent = (
    mixpanel: MixpanelGlobal,
    hasPerformanceConsent: boolean,
): void => {
    mixpanel.set_config?.({ disable_persistence: !hasPerformanceConsent });
};

const applySessionReplayConsent = (
    mixpanel: MixpanelGlobal,
    hasPerformanceConsent: boolean,
): void => {
    const configuredPercent = window._MIXPANEL_SESSION_REPLAY_PERCENT;
    if (!configuredPercent) {
        return;
    }

    if (!hasPerformanceConsent) {
        mixpanel.set_config?.({ record_sessions_percent: 0 });
        mixpanel.stop_session_recording?.();
        return;
    }

    mixpanel.set_config?.({ record_sessions_percent: configuredPercent });

    if (Math.random() * 100 <= configuredPercent) {
        mixpanel.start_session_recording?.();
    }
};

export const applyPerformanceConsentToMixpanel = (hasPerformanceConsent: boolean): void => {
    const mixpanel = getMixpanel();
    if (!mixpanel) {
        return;
    }
    applyPersistenceConsent(mixpanel, hasPerformanceConsent);
    applySessionReplayConsent(mixpanel, hasPerformanceConsent);
};
